import { FC } from 'react';
import { TypographyProps } from './types';
import { TypographyText } from './styles';
import { Flex } from '../flex';
import { Img } from '../imgStyledComponent';

export const Typography: FC<TypographyProps> = ({
	children,
	mode = 'small',
	isBold = false,
	truncate = false,
	colorVariant = 'default',
	whiteSpace = '',
	wordBreak = '',
	pointer = false,
	icon = {
		src: '',
	},
	textAlignCenter = false,
  isMixDiff = false,
	...rest
}) => {
	const content = (
		<TypographyText
			$mode={mode}
			$isBold={isBold}
			$colorVariant={colorVariant}
			$truncate={truncate}
			$whiteSpace={whiteSpace}
			$wordBreak={wordBreak}
			$pointer={pointer}
			$textAlignCenter={textAlignCenter}
      $isMixDiff={isMixDiff}
			{...rest}
		>
			{children}
		</TypographyText>
	);

	return icon.src ? (
		<Flex $alignItems={icon.align} $gap="5px" $cursor="pointer">
			<Img src={icon.src} $size={icon.size} />
			{content}
		</Flex>
	) : (
		content
	);
};
